// fetchVersionlist

// getAffiliatelist

// getuserlist

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchVersionlist, updateAndroidVersion, updateIosVersion } from "../../Api/AdminApiCall";

export const fetchgetversionApi = createAsyncThunk(
    "admin/fetchgetversionApi",
    async (_, { rejectWithValue }) => {
        try {
            const res = await fetchVersionlist();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load versions"
            );
        }
    }
);

export const fetchUpdateAndroidVersionApi = createAsyncThunk(
    "admin/fetchUpdateAndroidVersionApi",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await updateAndroidVersion(payload);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to update Android version"
            );
        }
    }
);

export const fetchUpdateIosVersionApi = createAsyncThunk(
    "admin/fetchUpdateIosVersionApi",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await updateIosVersion(payload);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to update iOS version"
            );
        }
    }
);

// export const fetVersionUpdate = createAsyncThunk(
//     "admin/fetVersionUpdate",
//     async ( payload, { rejectWithValue }) => {
//         try {
//             const res = await AdminupdateAffiliatetype(payload);
//             return res.data;
//         } catch (error) {
//             return rejectWithValue(
//                 error.response?.data || "Failed to load users"
//             );
//         }
//     }
// );

// AdminupdateAffiliatetype

// export const fetchgetAffiliateViewApi = createAsyncThunk(
//     "admin/fetchgetAffiliateViewApi",
//     async (id, { rejectWithValue }) => {
//         try {
//             const res = await getAffiliateView(id);
//             return res.data;
//         } catch (error) {
//             return rejectWithValue(
//                 error.response?.data || "Failed to load users"
//             );
//         }
//     }
// );

// getAffiliateView

// export const fetchExportAffiliatesApi = createAsyncThunk(
//     "admin/fetchExportAffiliatesApi",
//     async ({ search = '', status = '', affiliateType = '' }, { rejectWithValue }) => {
//         try {
//             const res = await exportAffiliates(search, status, affiliateType);
//             return res.data;
//         } catch (error) {
//             return rejectWithValue(
//                 error.response?.data || "Failed to export affiliates"
//             );
//         }
//     }
// );

const AdminVersionApiSlice = createSlice({
    name: "VersionApi",
    initialState: {
        VersionList: [],
        updateLoading: false,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchgetversionApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetversionApi.fulfilled, (state, action) => {
                state.loading = false;
                state.VersionList = action.payload;
            })
            .addCase(fetchgetversionApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Update Android Version
            .addCase(fetchUpdateAndroidVersionApi.pending, (state) => {
                state.updateLoading = true;
                state.error = null;
            })
            .addCase(fetchUpdateAndroidVersionApi.fulfilled, (state, action) => {
                state.updateLoading = false;
            })
            .addCase(fetchUpdateAndroidVersionApi.rejected, (state, action) => {
                state.updateLoading = false;
                state.error = action.payload;
            })
            // Update iOS Version
            .addCase(fetchUpdateIosVersionApi.pending, (state) => {
                state.updateLoading = true;
                state.error = null;
            })
            .addCase(fetchUpdateIosVersionApi.fulfilled, (state, action) => {
                state.updateLoading = false;
            })
            .addCase(fetchUpdateIosVersionApi.rejected, (state, action) => {
                state.updateLoading = false;
                state.error = action.payload;
            })
    },
});

const AdminVersionApiSliceReducer = AdminVersionApiSlice.reducer;

export default AdminVersionApiSliceReducer;
